import { Link } from "react-router-dom";
import { rankings } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

const topColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function RankSection() {
  const list = rankings.slice(0, 6);
  return (
    <section id="rank" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="大家都在追"
          title="热门排行"
          desc="根据人气与热度实时生成，看看本月最受欢迎的萌系与恋爱漫画。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((c, i) => (
            <Link
              key={c.id}
              to={`/comic/${c.id}`}
              className="group flex items-center gap-4 rounded-xl bg-background-50 p-3 transition-colors hover:bg-background-200/50"
            >
              <span
                className={`flex h-11 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg text-background-50 ${
                  topColors[i] || "bg-foreground-400"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-24 w-[4.5rem] shrink-0 overflow-hidden rounded-lg">
                <img
                  src={c.cover}
                  alt={`${c.title} 热门漫画封面`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 font-medium text-foreground-900">{c.title}</h3>
                <p className="mt-1 line-clamp-1 text-sm text-foreground-500">{c.author}</p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" />
                    {(c.views / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-line text-accent-500" />
                    {c.likes}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-secondary-500" />
                    {c.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}